import angular from 'angular';
import template from './template.html';
import './style.scss';
import Logger from '../../../../shared/logger';

export class CompleteJobDefinitionButton {
    /* @ngInject */
    constructor($scope, PositionService, WebAppRouteService) {
        this.positionService = PositionService;
        this.WebAppRouteService = WebAppRouteService;
    }

    async onCompleteJobDefinitionClick(event) {
        event.stopPropagation();
        if (this.isFetching) {
            return;
        }

        this.isFetching = true;

        try {
            const { stepName } = await this.positionService.getUploadJobCurrentWizardStep(this.positionId);

            this.WebAppRouteService.goToViewUploadWizardPage({
                employerId: this.employerId,
                positionId: this.positionId,
                stepName,
            });
        } catch (err) {
            Logger.error(err);
        } finally {
            this.isFetching = false;
        }
    }
}

export const CompleteJobDefinitionButtonConfiguration = {
    template,
    bindings: {
        positionId: '<',
        employerId: '<',
    },
    controller: CompleteJobDefinitionButton,
    controllerAs: 'btnCtrl',
};

angular.module('TALENYA-FE').component('completeJobDefinitionButton', CompleteJobDefinitionButtonConfiguration);
